import { Component, OnInit, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { TablesVisualizationUpdate } from 'src/app/interfaces/tableVisualizationUpdate';
import { ApplicationService } from '../application.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ScrollbarModule, IconModule } from '@michelin/theme';
import { MatOption } from '@angular/material/autocomplete';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mic-table-visualization-modal',
  templateUrl: './table-visualization-modal.component.html',
  styleUrls: ['./table-visualization-modal.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDivider,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    ScrollbarModule,
    MatOption,
    MatCheckbox,
    MatTooltip,
    IconModule,
    MatDialogActions,
    MatButton
  ]
})
export class TableVisualizationModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<TableVisualizationModalComponent>>(MatDialogRef);
  private readonly applicationService = inject(ApplicationService);
  tableVisualizationUpdated = inject<TablesVisualizationUpdate>(MAT_DIALOG_DATA);

  tableVisualization: FormGroup;
  filterConfArray: FormGroup[] = [];

  columnIdsToRemove: number[] = [];

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    this.preparMethod();
    this.tableVisualization = new FormGroup({
      name: new FormControl(
        this.tableVisualizationUpdated.tableVisualization ? this.tableVisualizationUpdated.tableVisualization.name : null,
        Validators.required
      ),
      tableName: new FormControl(
        this.tableVisualizationUpdated.tableVisualization ? this.tableVisualizationUpdated.tableVisualization.tableName : null,
        Validators.required
      ),
      connectionDBId: new FormControl(
        this.tableVisualizationUpdated.tableVisualization ? this.tableVisualizationUpdated.tableVisualization.connectionDB.id : null,
        Validators.required
      ),
      columnCsvList: new FormArray(this.filterConfArray),
      whereClose: new FormControl(
        this.tableVisualizationUpdated.tableVisualization ? this.tableVisualizationUpdated.tableVisualization.whereClose : null
      )
    });
  }

  private preparMethod(): void {
    if (this.tableVisualizationUpdated.tableVisualization) {
      this.tableVisualizationUpdated.tableVisualization.columnCsvList.forEach((column) => {
        const group = new FormGroup({
          id: new FormControl(column.id),
          name: new FormControl(column ? column.name : null, Validators.required),
          primaryKey: new FormControl(column ? column.primaryKey : false),
          updateUser: new FormControl(column ? column.updateUser : false),
          updateDate: new FormControl(column ? column.updateDate : false),
          filterable: new FormControl(column ? column.filterable : false),
          updatable: new FormControl(column ? column.updatable : false)
        });
        this.filterConfArray.push(group);
      });
    } else {
      const group = new FormGroup({
        name: new FormControl(null),
        primaryKey: new FormControl(false),
        updateUser: new FormControl(false),
        updateDate: new FormControl(false),
        filterable: new FormControl(false),
        updatable: new FormControl(false)
      });
      this.filterConfArray.push(group);
    }
  }

  onClose(close: boolean): void {
    this.dialogRef.close(close);
  }
  onAddColumn() {
    const group = new FormGroup({
      name: new FormControl(null, Validators.required),
      primaryKey: new FormControl(false),
      updateUser: new FormControl(false),
      updateDate: new FormControl(false),
      filterable: new FormControl(false),
      updatable: new FormControl(false)
    });
    (this.tableVisualization.get('columnCsvList') as FormArray).push(group);
  }

  onDeleteColumn(i: number) {
    if ((this.tableVisualization.get('columnCsvList') as FormArray).at(i).value.id) {
      this.columnIdsToRemove.push((this.tableVisualization.get('columnCsvList') as FormArray).at(i).value.id);
    }

    (this.tableVisualization.get('columnCsvList') as FormArray).removeAt(i);
    (this.tableVisualization.get('columnCsvList') as FormArray).markAsDirty();
  }
  checkboxChanged(event: MatCheckboxChange) {
    console.log(event);
  }

  onSubmit(): void {
    if (this.tableVisualizationUpdated.tableVisualization) {
      const newData = { ...this.tableVisualization.value, columnsCsvIdsToRemove: this.columnIdsToRemove };
      this.applicationService
        .updateTableVisualization(this.tableVisualizationUpdated.tableVisualization.id, newData)
        .subscribe((result) => {
          this.dialogRef.close(result);
        });
    } else {
      this.applicationService.addTableVisualization(this.tableVisualization.value).subscribe((response) => {
        this.dialogRef.close(response);
      });
    }
  }

  get controls() {
    return (this.tableVisualization.get('columnCsvList') as FormArray).controls;
  }
}
